// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"layout-module--breadcrumb--3m327","separator":"layout-module--separator--3loVb","page":"layout-module--page--2zHht","wrapper":"layout-module--wrapper--Jy0BJ"};